// extracted by mini-css-extract-plugin
export default {"root":"_3GlUj","small":"f2di8","normal":"_2I8VJ"};